import { Link } from "react-router-dom";
import { categoryUrl } from "../../utils/categoryUrl";

const categoryImages = {
  "صندل زنانه": "women-sandals.webp",
  "کفش پرسنلی": "women-work-shoes.webp",
  "اسپورت": "women-sport-shoes.webp",
  "کفش مجلسی": "women-formal-shoes.webp",
};

const layoutClassMap = {
  auto: "",
  wide: "category-layout-wide",
  tall: "category-layout-tall",
  small: "category-layout-small",
};

const CategoryCard = ({ category, imageIndex, index, total }) => {
  const imageName = categoryImages[category.name];

  const imageSrc = category.image
    ? `/storage/${category.image}`
    : imageName
      ? `/storage/categories/${imageName}`
      : `./images/slider/${imageIndex}.jpg`;

  return (
    <Link
      to={categoryUrl(category)}
      className={`
        category-card
        category-card-${index % 6}
        category-count-${total}
        ${layoutClassMap[category.layout_type] || ""}
      `}
      aria-label={category.name}
    >
      <span className="category-card-image">
        <img
          src={imageSrc}
          alt={category.name}
          loading="lazy"
          onError={(event) => {
            event.currentTarget.src = `./images/slider/${imageIndex}.jpg`;
          }}
        />
      </span>
    </Link>
  );
};

export default CategoryCard;
